import type { Product } from 'reactApp/types/Billing';

export interface Props {
    file?: IFile;
    files?: IFiles;
    numberOfFiles: number;
    onClose: () => void;
    continueFileLoading: () => void;
    skipFileLoading: () => void;
}

export interface TariffInfo {
    trial?: Product;
    usualProduct?: Product;
    transactProduct?: Product;
    showTariffType: EShowTariffType;
}

export interface Content {
    header: string | JSX.Element;
    description: string | JSX.Element;
    annotation: string | JSX.Element;
    actions: JSX.Element | null;
}

export enum EShowTariffType {
    USUAL_TARIFF = 'usual_tariff',
    TRANSACT = 'transact',
    TRIAL = 'trial',
}

interface IFile {
    extension: string;
    name: string;
    sizeBytes: number;
}

interface IFiles {
    size: string;
    number: number;
    sizeBytes: number;
}

export type BigFileModalStage = 'usual' | 'transact';

export interface IBigFileModalContent {
    tariffInfo: TariffInfo;
    numberOfFiles: number;
    callbacks: IModalCallbacks;
    files?: IFiles;
    file?: IFile;
    stage: BigFileModalStage;
}

export interface IModalCallbacks {
    onSkip: () => void;
    onRequestPayment: () => void;
    onClose: () => void;
    sendAnalytics: (label: string) => void;
    // tempexp_18869-next-line
    onRequestHeavyFile: () => void;
    proposedTariff?: Product;
}

export const FILES_PLURAL = [
    'Не может быть загружен {count} файл',
    'Не могут быть загружены {count} файла',
    'Не могут быть загружены {count} файлов',
];
